import { oidcLogoutUser } from "src/features/auth/store/actions/auth/login";
import { useDispatch } from "react-redux";
function LogoutSuccessPage() {
    const dispatch = useDispatch();
    dispatch(oidcLogoutUser());
    return null;
}
export default LogoutSuccessPage;
